import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getDeviceByRadioId } from './helpers/get-device-by-radio-id';
import { normalizeRadioIdForServiceCallWithSupportForUUID } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getDeviceIdByRadioId(
    { radioId }: { radioId: string },
    dependencies: DependenciesPayload,
) {
    try {
        const { deviceId } = await getDeviceByRadioId(
            {
                radioId:
                    normalizeRadioIdForServiceCallWithSupportForUUID(radioId),
            },
            dependencies,
        );
        return deviceId;
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
